export const AlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.0003 5.94852L17.9028 17.8743H4.09783L11.0003 5.94852ZM11.0003 2.29102L0.916992 19.7077H21.0837L11.0003 2.29102Z"
        fill="#F07E35"
      />
      <path
        d="M11.917 15.1243H10.0837V16.9577H11.917V15.1243Z"
        fill="#F07E35"
      />
      <path
        d="M11.917 9.62435H10.0837V14.2077H11.917V9.62435Z"
        fill="#F07E35"
      />
    </svg>
  );
};
